import type { ReactElement } from "react";
import { RouterProvider } from "@tanstack/react-router";
import { I18nextProvider } from "react-i18next";
import { AuthProvider } from "./lib/auth/AuthContext";
import { i18n } from "./lib/i18n/i18n";
import { router } from "./router";

export function App(): ReactElement {
  return (
    <I18nextProvider i18n={i18n}>
      <AuthProvider>
        <RouterProvider router={router} />
      </AuthProvider>
    </I18nextProvider>
  );
}
